<template lang="pug">
#modal-cancelamento-laudo
    el-dialog(
        :title='$t("mensagens.laudos.CancelamentoDeLaudo")',
        width='500px',
        :visible.sync='show',
        :close-on-click-modal='false',
        @close='closeDialog()',
        @voltar='voltar()'
    )
        p {{ $t('mensagens.laudos.mensagemCancelamento') }}
        p
            b {{ $t('mensagens.laudos.tipoDeLaudo') }}:
            | {{ informacoesLaudo.tipoDeLaudo }}
        p {{ laudoLabel }}
        div(v-if='informacoesLaudo.nomeTerritorio')
            p
                b {{ $t('mensagens.laudos.territorio') }}:
                | {{ informacoesLaudo.nomeTerritorio }}
            .mapa
                Mapa(
                    :mapLayersConfigs='layersMaps',
                    :mapConfig='mapConfig',
                    :height='"100%"',
                    :idMapa='"mapaVizualizacaoLaudo"',
                    locked
                )
            p
                b {{ $t('mensagens.laudos.localidade') }}:
                | {{ informacoesLaudo.localidadeTerritorio?.localidadeFormatada }}
        el-form(label-position='top')
            el-form-item(:label='$t("mensagens.laudos.motivoCancelamento")')
                el-input.w-100(
                    type='textarea',
                    :rows='4',
                    v-model='motivoCancelamento',
                    :placeholder='$t("mensagens.laudos.motivoCancelamentoDescricao")'
                )
        footer.espaco(slot='footer')
            el-button(type='default', @click='closeDialog()') {{ $t('mensagens.comuns.voltar') }}
            el-button(type='primary', @click='cancelarSolicitacao') {{ $t('mensagens.laudos.cancelarSolicitacao') }}
</template>

<script>
import Mapa from '@/components/MapaLeaflet.vue';
import TipoLaudo from '@/constants/TipoLaudo';
import LaudosService from '@/services/LaudosService';
import { getEstiloGeometria } from '@/utils/mapa/mapa.estilos';

export default {
    name: 'ModalCancelamentoLaudo',
    components: { Mapa },
    props: {
        idLaudo: { type: Number | null, required: true },
        tipoLaudo: { type: Number, required: true },
        show: { type: Boolean, required: true }
    },
    data() {
        return {
            informacoesLaudo: {
                municipioTerritorio: { estado: {} },
                geometriaTerritorio: {},
                localidadeTerritorio: {}
            },
            layersMaps: [],
            mapConfig: { controls: {} },
            motivoCancelamento: ''
        };
    },
    computed: {
        laudoLabel() {
            const labels = {
                [TipoLaudo.AGRICOLA]: this.$t('mensagens.laudos.laudoAgricola'),
                [TipoLaudo.AVALIACAO_DE_AREA_PRODUTIVA]: this.$t(
                    'mensagens.laudos.avaliacaoDeAreaProdutiva'
                ),
                [TipoLaudo.AVALIACAO_FUNDIARIA]: this.$t(
                    'mensagens.laudos.laudoAvaliacaoFundiaria'
                ),
                [TipoLaudo.AVALIACAO_SOCIOAMBIENTAL]: this.$t(
                    'mensagens.laudos.avaliacaoSocioambiental'
                ),
                [TipoLaudo.BACEN_FISCALIZACAO]: this.$t(
                    'mensagens.laudos.bacenFiscalizacaoRemota'
                ),
                [TipoLaudo.BENFEITORIAS]: this.$t('mensagens.laudos.benfeitorias'),
                [TipoLaudo.CARBONO]: this.$t('mensagens.laudos.carbono'),
                [TipoLaudo.CONFORMIDADE]: this.$t(
                    'mensagens.laudos.laudoConformidadeAmbientalDoCar'
                ),
                [TipoLaudo.DIAGNOSTICO_AGRICOLA]: this.$t(
                    'mensagens.laudos.diagnosticoAgricola'
                ),
                [TipoLaudo.HISTORICO_AGRICOLA]: this.$t(
                    'mensagens.laudos.historicoAgricola'
                ),
                [TipoLaudo.RENOVABIO]: this.$t(
                    'mensagens.laudos.laudoElegibilidadeRenovabio'
                ),
                [TipoLaudo.SUPRESSAO_VEGETAL]: this.$t('mensagens.laudos.supressaoVegetal'),
                [TipoLaudo.TECNICO_AGRICOLA]: this.$t('mensagens.laudos.tecnicoAgricola'),
                [TipoLaudo.ANALISE_DE_COBERTURA_DE_SOLO]: this.$t('mensagens.laudos.analiseDeCoberturaDoSolo')
            };

            return labels[this.tipoLaudo] || '';
        }
    },
    methods: {
        getInformacoes() {
            if (!this.idLaudo) return null;
            LaudosService.getInformacoesByIdLaudo(this.idLaudo)
                .then(({ data }) => {
                    this.informacoesLaudo = data;
                    setTimeout(() => this.mostrarTerritorioNoMapa(), 500);
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.laudos.erro.naoFoiPossivelBuscarAsInformacoesDoLaudo'
                        )
                    });
                });
        },
        mostrarTerritorioNoMapa() {
            this.layersMaps = [];
            let layerTerritorio = {
                style: getEstiloGeometria('area'),
                name: 'Território Laudo',
                geoJson: this.informacoesLaudo.geometriaTerritorio
            };
            this.layersMaps.push(layerTerritorio);
        },
        closeDialog() {
            this.motivoCancelamento = '';
            this.$emit('update:show', false);
        },
        async cancelarSolicitacao() {
            try {
                await LaudosService.cancelarLaudo({
                    id: this.idLaudo,
                    motivoCancelamento: this.motivoCancelamento
                });
                this.closeDialog();
                this.voltar();
                this.$notify.success({
                    message: this.$t(
                        'mensagens.laudos.laudoCanceladoComSucesso'
                    )
                });
            } catch (e) {
                this.$notify.error({
                    message: e.response.data.message
                });
            }
        },
        voltar() {
            this.motivoCancelamento = '';
            this.$emit('voltar');
        }
    },
    watch: {
        idLaudo() {
            this.getInformacoes();
        }
    },
    created() {
        this.getInformacoes();
    }
};
</script>

<style lang="scss">
#modal-cancelamento-laudo {
    footer {
        display: flex;
        justify-content: space-between;
    }

    .mapa {
        height: 150px;
        border-radius: 4px;
        overflow: hidden;
        margin: 0 0 20px 0;
    }

    .espaco {
        display: flex;
    }

    .el-form-item .el-form-item__label {
        font-weight: normal !important;
    }
}
</style>
